import React from "react";

const Select = ({ options, onChange, value, id }) => {
  const handleChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <div className="relative">
      <select
        id={id}
        value={value || ""}
        onChange={handleChange}
        className="appearance-none bg-white border-2 border-black rounded-md py-2 px-4 pr-8 text-black font-medium cursor-pointer hover:border-[#ad885d] focus:outline-none focus:border-[#ad885d] min-w-[150px]"
      >
        {options && options.length > 0 ? (
          options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))
        ) : (
          <option value="">No options</option>
        )}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-black">
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  );
};

export default Select;
